import { GetListParams } from 'ra-core';

import { API_HANDLERS } from '@/api';
import { IEmployeesRequestParams } from '@/types';

export const exportEmployees = async (data?: Partial<GetListParams>): Promise<any> => {
  try {
    const requestData: IEmployeesRequestParams = {
      filter: {
        companyId: data?.filter?.companyId,
        cohortId: data?.filter?.cohortId,
        status: data?.filter?.status,
      },
      search: data?.filter.full_name,
      page: data?.pagination?.page,
      order: data?.sort?.order,
      take: data?.pagination?.perPage,
    };

    const response = await API_HANDLERS.EMPLOYEES.EXPORT(requestData);

    return response;
  } catch (error) {
    return Promise.reject(new Error(`Export Employees XLS Error: ${error}`));
  }
};
